import { useEffect, useState } from "react";
import {LeaderboardApi} from "../../api/LeaderboardApi";
import SteminpeLeaderboard from "./SteminpeLeaderboard";

const leaderboardInfo = {
    heading: "STEAMinPE比賽",
    subHeading: "最喜愛設計大獎",
    unit: "",
};

const SteminpeLeaderboardTopPlaySkill = () => {
    const [leaderboardData, setLeaderboardData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        let isMounted = true;
        loadLeaderboard();

        return () => {
            isMounted = false;
        };
    }, []);

    const loadLeaderboard = async () => {
        setIsLoading(true);
        setError(null);

        try {
            const result = await LeaderboardApi.getTopSkillParticipantCount();

            // if (!isMounted) return;

            const transformedData = (result || []).map(
                ({ id, name_zh, name_en, code, rank, member_count }) => ({
                    id,
                    itemName: name_zh,
                    itemNameEn: name_en,
                    code,
                    rank,
                    score: member_count,
                })
            );

            setLeaderboardData(transformedData);
        } catch (err) {
            // if (isMounted) {
            setError(err);
            // }
        } finally {
            // if (isMounted) {
                setIsLoading(false);
            // }
        }
    };

    if (error) {
        return null;
    }

    return (
        <SteminpeLeaderboard
            leaderboardInfo={leaderboardInfo}
            leaderboardData={leaderboardData}
            isLoading={isLoading}
        />
    );
};

export default SteminpeLeaderboardTopPlaySkill;